module.exports = __webpack_public_path__ + "img/SV.1f2e7466.svg";